import { isUndefined } from 'lodash';
import { ChangeEvent, ReactElement } from 'react';
import { RadioGroupProps } from '../../../types';

export const useRadioGroup = ({
    value,
    onChange,
}: {
    value: RadioGroupProps['value'];
    onChange: RadioGroupProps['onChange'];
}) => {
    const getExtendedProps = (child: ReactElement) => {
        const controlled = !isUndefined(value);

        const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
            if (typeof onChange === 'function') {
                onChange?.(e.target.value);
            }

            const childOnChange = (child as ReactElement)?.props?.onChange;
            if (typeof childOnChange === 'function') {
                childOnChange(e);
            }
        };

        return {
            onChange: handleChange,
            ...(controlled ? { checked: Boolean(child.props.value === value) } : {}),
        };
    };

    return { getExtendedProps };
};
